import {Injectable} from '@angular/core';

@Injectable()
export class CommandsGuiProgressBar {
    constructor() {

    }

    createProgBar() {
    }

    updateProgBar() {
    }
}
